import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=2f6d1353&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d1353",
  null
  
)

export default component.exports